import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import LandingPage from "./pages/LandingPage";
import TermsAndConditions from "./pages/TermsAndConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { NavigationBar, Footer } from "./components";

const FooterWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isTermsPage",
})<{ isTermsPage: boolean }>(({ isTermsPage, theme }) => ({
  backgroundColor: isTermsPage
    ? "var(--background-white)"
    : "var(--background-page)",
  paddingBottom: theme.spacing(5),
  [theme.breakpoints.down("md")]: {
    paddingBottom: theme.spacing(2),
  },
}));

function AppContent() {
  const location = useLocation();

  const isTermsPage =
    location.pathname === "/privacy-policy" ||
    location.pathname === "/terms-and-conditions";

  return (
    <div className="App">
      <NavigationBar />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <FooterWrapper isTermsPage={isTermsPage}>
        <Footer />
      </FooterWrapper>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
